import { publicClient, privateClient } from './client';
import { SearchDisplay } from './SearchDisplay';

const transactionsSearchDisplay = (pub: boolean) => new SearchDisplay(pub ? publicClient : privateClient);
export default transactionsSearchDisplay;
